module.exports = __webpack_public_path__ + "images/emoji/clock230.4b6e60f0fcaeef2099a5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock230.png
// module id = h9ps
// module chunks = 24